export enum ImportStep {
    Upload = 0,
    ControlColumn = 5,
    Series = 10,
    OutcomeColumn = 15,
    Formula = 20,
    NewLost = 25,
    AggregationSettings = 30,
    CalcOptions = 35,
    RelativeImpactOptions = 40,
    Dimensions = 45,
    PreaggregationStrategy = 50,
    Forecast = 55,
    Cards = 80,
}